export async function aggregateCountPosNegAsync(data, arrayFlag, posNegFields, divider, round) {
    return new Promise( function(resolve){
        const aggWorker = new Worker("workers/aggregationPosNeg.js");
        aggWorker.onmessage = function (e) {
            // console.log("received message");
            resolve(e.data);
        }
        aggWorker.postMessage([data, arrayFlag, posNegFields, divider, round]);
    })
}